import { useState } from 'react';
import { useSelector } from 'react-redux';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import CssBaseline from '@mui/material/CssBaseline';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Viewport from 'app/components/Viewport';
import SideNav from 'app/components/SideNav';
import { UploadWorkerProvider } from 'app/workers/UploadWorker';
import ConfirmModalProvider from 'app/components/Modal/ConfirmModalProvider';

import {
  updateMe
} from 'shared/services/user';

const Home = props => {
  const {
    children
  } = props;

  const user = useSelector(state => state.userReducer.user);
  const [navIsOpen, setNavIsOpen] = useState(!user.collapse_nav);

  const onNavOpen = () => {
    setNavIsOpen(true);
    updateMe({ collapse_nav: false });
  }

  const onNavClose = () => {
    setNavIsOpen(false);
    updateMe({ collapse_nav: true });
  }

  let drawerWidth = navIsOpen ? 240 : 85;

  let style = {
    position: 'relative',
    display: 'block',
    height: '100vh',
    width: `calc(100vw - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    overflow: 'hidden'
  }

  return (
    <UploadWorkerProvider>
      <ConfirmModalProvider>
        <Viewport>
          <SideNav
            isOpen={navIsOpen}
            onOpen={onNavOpen}
            onClose={onNavClose}
            drawerWidth={drawerWidth}
          />
          <div style={style}>
            {children}
          </div>
        </Viewport>
      </ConfirmModalProvider>
    </UploadWorkerProvider>
  )
}

export default Home;
